import { render, staticRenderFns } from "./Headr.vue?vue&type=template&id=3c181179&scoped=true&"
import script from "./Headr.vue?vue&type=script&lang=js&"
export * from "./Headr.vue?vue&type=script&lang=js&"
import style0 from "./Headr.vue?vue&type=style&index=0&id=3c181179&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c181179",
  null
  
)

export default component.exports